import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'toPregnancyStatusIcon',
  standalone: true
})
export class ToPregnancyStatusIconPipe implements PipeTransform {
  constructor() {
  }

  public transform(status?: any): string {
    if (status == undefined) {
      return "fa-solid fa-circle-minus"
    }

    switch (status) {
      case 'CONFIRMED': return "fa-solid fa-circle-plus color-pink"
      case 'ESTIMATED': return "fa-solid fa-circle-plus color-warning"
      case 'ABORTED': return "fa-solid fa-circle-minus"
      default: return "fa-solid fa-circle-minus"
    }
  }
}
